import React from 'react';
import { EmailBlock, HtmlBlockContent } from '../../types';

// HtmlProperties component for email builder

interface HtmlPropertiesProps {
  block: EmailBlock;
  onUpdate: (updates: Partial<HtmlBlockContent>) => void;
  mergeTags?: Array<{ name: string; value: string; sample: string }>;
  isDarkMode: boolean;
}

export const HtmlProperties: React.FC<HtmlPropertiesProps> = ({
  block,
  onUpdate,
  isDarkMode
}) => {
  const content = block.content as HtmlBlockContent;

  return (
    <div className="space-y-4">
      <div>
        <label className={`
          block text-sm font-medium mb-1
          ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}
        `}>
          HTML Content
        </label>
        <textarea
          value={content.html || ''}
          onChange={(e) => onUpdate({ html: e.target.value })}
          className={`
            w-full px-3 py-2 border rounded-md font-mono text-sm resize-none
            ${isDarkMode 
              ? 'bg-gray-700 border-gray-600 text-white' 
              : 'bg-white border-gray-300 text-gray-900'
            }
          `}
          rows={10}
          placeholder="<p>Custom HTML content</p>"
        />
        <p className={`
          mt-1 text-xs
          ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}
        `}>
          Enter raw HTML code. Merge tags like {'{{firstName}}'} will be replaced when sending.
        </p>
      </div>
    </div>
  );
};
